import "./component1.scss";
import React from "react";
import { Link } from "react-router-dom";
import image_icon from "../../Images/image_icon.png";
import {
  ADDRESS_LINE,
  MAP_LINK,
  METRO_LINES,
  PHONE_BOOKING_DISPLAY,
  PHONE_BOOKING_TEL,
  PHONE_MAIN_DISPLAY,
  PHONE_MAIN_TEL,
  TELEGRAM_CHANNEL_URL,
} from "../../constants/contact";

const Component1 = () => {
  return (
    <header className="hero component1" id="top">
      <div className="hero__bg" aria-hidden="true" />
      <div className="hero__grid container">
        <div className="hero__top">
          <a
            className="hero__address"
            href={MAP_LINK}
            target="_blank"
            rel="noreferrer"
          >
            <span className="hero__address-line">{ADDRESS_LINE}</span>
            <span className="hero__metro">{METRO_LINES.join(" · ")}</span>
          </a>

          <Link className="hero__brand" to="/" aria-label="На главную">
            <img className="hero__logo" src={image_icon} alt="" />
          </Link>

          <div className="hero__phones">
            <span className="hero__phones-label">Бронирование</span>
            <a className="hero__tel" href={PHONE_BOOKING_TEL}>
              {PHONE_BOOKING_DISPLAY}
            </a>
            <span className="hero__phones-label hero__phones-label--muted">
              Стойка клуба
            </span>
            <a className="hero__tel" href={PHONE_MAIN_TEL}>
              {PHONE_MAIN_DISPLAY}
            </a>
          </div>
        </div>

        <div className="hero__body">
          <p className="section-label hero__eyebrow">Москва · бильярд · лаунж</p>
          <h1 className="hero__title">Бильярдный клуб «ЛИГА»</h1>
          <p className="hero__subtitle">
            Атмосферное место для отдыха с друзьями — продуманный интерьер,
            премиальные столы, бар и кухня на любой вкус.
          </p>
          <div className="hero__actions">
            <a className="cta-phone" href={PHONE_BOOKING_TEL}>
              Позвонить сейчас
            </a>
            <a className="cta-phone cta-phone--ghost" href={PHONE_BOOKING_TEL}>
              {PHONE_BOOKING_DISPLAY}
            </a>
            <Link className="hero__ghost-link" to="/menu">
              Меню бара и кухни
            </Link>
            <div className="hero__telegram">
              <p className="hero__telegram-label">Акции, новости и конкурсы</p>
              <a
                className="hero__telegram-btn"
                href={TELEGRAM_CHANNEL_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Перейти в Telegram
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Component1;
